<template>
    <v-container fluid class="pa-1">
        <v-layout wrap align-end justify-space-around>
            <template v-for="step in steps">
                <v-flex shrink :key="step.step" :class="[{'step-active': currentStep == step.step}, 'step-' + step.step]">
                    <v-tooltip bottom>
                        <v-icon small slot="activator">
                            <template v-if="step.step == currentStep">{{ stepIconActive }}</template>
                            <template v-else>{{ (step.icon ? step.icon : stepIcon) }}</template>
                        </v-icon>
                        <span v-if="step.step == currentStep">{{ $t('Current State') }}: </span>{{ step.text }}
                    </v-tooltip>
                </v-flex>
                <v-flex grow v-if="step.step != steps.length - 1"></v-flex>
            </template>
        </v-layout>
        <v-layout class="ma-1">
            <v-flex xs12>
                <v-progress-linear
                    class="ma-0"
                    height="10"
                    :value="trackingProgress()"
                    :color="trackingProgressColor()"
                    :background-color="color"
                ></v-progress-linear>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    name : 'tracking-progress',
    props: {
        currentStep: {
            type   : Number,
            default: 0 // 0-5
        },
        color: {
            type   : String,
            default: null
        }
    },
    data() {
        return {
            stepIcon:       'far fa-flag',// fa-map-marker-alt ',//'place',
            stepIconActive: 'fa-shipping-fast',
            steps: [
                { step: 0, text: this.$t('ShipmentRoutingState.CCCCL'), matches: 'CCCCL', icon: 'fa-laptop' }, // Приета заявка в системата / (this.$t('Collected'))
                { step: 1, text: this.$t('ShipmentRoutingState.CCCCS'), matches: 'CCCCS', icon: 'far fa-flag faded' }, // Взета от куриер
                { step: 2, text: this.$t('ShipmentRoutingState.DDDDD'), matches: 'DDDDD' }, // В склад за претоварване
                { step: 3, text: this.$t('ShipmentRoutingState.DDDDE'), matches: 'DDDDE' }, // В склад за доставка
                { step: 4, text: this.$t('ShipmentRoutingState.DDDDF'), matches: 'DDDDF', icon: 'far fa-flag faded' }, // Доставя се
                { step: 5, text: this.$t('Delivered'),                  matches: '^F.+',  icon: 'fa-flag-checkered' }, // F статуси
            ],
        }
    },
    methods: {
        trackingProgress() {
            return (this.currentStep / (this.steps.length - 1)) * 100;
        },
        trackingProgressColor() {
            return 'hsla(' + this.trackingProgress() + ', 90%, 60%, 1)';
        },
    },
}
</script>
<style scoped>
.step-active .v-icon {
    text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
}
.v-icon.faded {
    opacity: .5;
}
</style>